/**
 * Configuración de producto — el módulo ÚNICO donde se decide qué es la app.
 *
 * La app es sólo DEENEX Activa. El resto (dashboard, objectives, segments, notifications,
 * whatsapp de Meta, audience, brand, wallet, integrations, settings) es la plataforma anterior:
 * no se borra, pero con SOLO_ACTIVA no se muestra en el menú, sus rutas redirigen a HOME, como
 * todo lo que antes caía en /dashboard (login, logo, «/», comodín, SSO).
 *
 * Volver al producto completo es poner SOLO_ACTIVA = false acá y LEGACY_MODULES=true en el
 * backend (que es el que monta la API de esos módulos).
 */

/** true = la app es sólo DEENEX Activa. */
export const SOLO_ACTIVA = true;

/** El nombre del producto que se ve (el login, la pestaña). «Deenex AI» era la plataforma anterior. */
export const NOMBRE_PRODUCTO = SOLO_ACTIVA ? "DEENEX Activa" : "Deenex AI";

/**
 * Adonde va un usuario logueado que no pidió otra cosa. Desde el 07/10/2026 es el Resumen de WhatsApp: es la
 * primera sección del menú y el canal que se opera todos los días. Antes era /activa (las campañas por archivo,
 * hoy «Reactivación»), y se entraba a una pantalla que no era la que el menú ponía primero.
 */
export const HOME = SOLO_ACTIVA ? "/activa/oficial" : "/dashboard";

/** Pantallas de entrada: volver a ellas después del login dejaría al usuario en un rulo. */
const ENTRADAS = new Set(["/login", "/sso-entry"]);

/**
 * Adónde va el usuario después de loguearse (o si abre /login ya logueado).
 *
 * ProtectedRoute guarda en `state.from` el Location de la URL que se pidió sin sesión: si es una
 * ruta propia, se vuelve ahí y el deep-link no se pierde. El state viaja en el history y su forma
 * no está garantizada, así que se valida todo: sólo rutas que empiezan con «/» y no con «//»
 * (el navegador lee «//evil.com» como otro origen, y eso sería un redirect abierto). Cualquier
 * otra cosa cae en HOME.
 */
export function destinoPostLogin(state: unknown): string {
  const from = (state as { from?: unknown } | null | undefined)?.from;
  if (!from || typeof from !== "object") return HOME;
  const { pathname, search } = from as { pathname?: unknown; search?: unknown };
  if (typeof pathname !== "string" || !pathname.startsWith("/") || pathname.startsWith("//")) return HOME;
  if (ENTRADAS.has(pathname)) return HOME;
  return pathname + (typeof search === "string" ? search : "");
}
